// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"styles_closeButton__NBLvR","closeButtonL":"styles_closeButtonL__jv41G","closeButtonS":"styles_closeButtonS__u9aBl"};